export const MAX_INVOICE_POLL_COUNT = 12 // 12 * 10 seconds = 120 seconds max polling
export const INVOICE_POLL_INTERVAL = 10000 // 10 seconds
export const INITIAL_POLL_DELAY = 20000 // 20 seconds initial delay
